import { render, staticRenderFns } from "./FormBuilderModal.vue?vue&type=template&id=375faf4b&scoped=true"
import script from "./FormBuilderModal.vue?vue&type=script&lang=js"
export * from "./FormBuilderModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375faf4b",
  null
  
)

export default component.exports